import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/white-lux.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pt-10 px-10 flex justify-center align-middle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"25%"}
  }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-spinner" }
const _hoisted_8 = {
  class: "spinner",
  width: "65px",
  height: "65px",
  viewBox: "0 0 66 66",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = {
  class: "path",
  fill: "none",
  "stroke-width": "6",
  "stroke-linecap": "round",
  cx: "33",
  cy: "33",
  r: "30"
}
const _hoisted_10 = { class: "modal-text" }
const _hoisted_11 = { class: "left-buttons" }
const _hoisted_12 = { class: "right-buttons" }
const _hoisted_13 = {
  key: 1,
  class: "disabled-button nes-btn huVjiU uxbuttonright"
}
const _hoisted_14 = { class: "staking-info flex justify-center huVjiU" }
const _hoisted_15 = {
  key: 0,
  class: "accrued-reward uxbuttonleft left-buttons"
}
const _hoisted_16 = {
  key: 1,
  class: "currently-earning uxbuttonright right-buttons"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " Staking account not found. Click here to create a new one. ", -1)
const _hoisted_19 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_ConfigPane),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Modal, {
                  onClose: _ctx.toggleModal,
                  modalActive: _ctx.modalActive,
                  modalBad: _ctx.modalBad,
                  modalGood: _ctx.modalGood,
                  modalNeutral: _ctx.modalNeutral,
                  modalShowClose: _ctx.modalShowClosebutton
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.ModalHeader), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_8, [
                          _withDirectives(_createElementVNode("circle", _hoisted_9, null, 512), [
                            [_vShow, _ctx.modalShowWheel]
                          ])
                        ], 512)), [
                          [_vShow, _ctx.modalShowWheel]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.ModalMessage), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["onClose", "modalActive", "modalBad", "modalGood", "modalNeutral", "modalShowClose"]),
                (_openBlock(), _createBlock(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farmerAcc: _ctx.farmerAcc,
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onSelectedVaultNft: _ctx.handleNewSelectedVaultNFT,
                  ref: "VaultRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "nes-btn huVjiU is-primary uxbuttonleft",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                          }, " Add NFTs (resets lock timer) "))
                        : _createCommentVNode("", true),
                      (_ctx.farmerState === 'unstaked' && !_ctx.widthdrawNFTs)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "enabled-button nes-btn huVjiU is-success uxbuttonleft",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                          }, " Start Staking "))
                        : _createCommentVNode("", true),
                      (_ctx.farmerState === 'unstaked'  && _ctx.widthdrawNFTs)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "enabled-button nes-btn huVjiU is-success uxbuttonleft",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                          }, " Withdraw NFTs "))
                        : _createCommentVNode("", true),
                      (_ctx.farmerState === 'staked')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: "enabled-button nes-btn huVjiU is-error uxbuttonleft",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.endStaking(true)))
                          }, " Stop Staking "))
                        : _createCommentVNode("", true),
                      (_ctx.farmerState === 'pendingCooldown')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            class: "enabled-button nes-btn huVjiU is-error uxbuttonleft",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.endStaking(true)))
                          }, " Stop Staking "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_ctx.availableA > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "enabled-button nes-btn huVjiU uxbuttonright",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                          }, " Claim " + _toDisplayString(_ctx.availableA / 1000000000) + " $LUX ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.availableA == 0)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_13, " Withdraw " + _toDisplayString(_ctx.availableA / 1000000000) + " $LUX ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.accruedReward)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Pending Rewards: " + _toDisplayString((_ctx.accruedReward - _ctx.paidOutReward) / 1000000000) + " $LUX", 1))
                        : _createCommentVNode("", true),
                      (_ctx.fixedRate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Currently generating: " + _toDisplayString(_ctx.fixedRate / 1000000000) + " $LUX per Week", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["vault", "farmerAcc", "onSelectedWalletNft", "onSelectedVaultNft"]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "nes-btn huVjiU",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " New staking account ")
                ])
              ]))
        ]))
  ], 64))
}